import { useState } from 'react'

import BlockedUrlsModal from './BlockedUrlsModal'

import parentStyles from '@/pages/app/Settings/styles.module.scss'

import Button from '@/components/Button'
import { EnterpriseSettings, SettingType } from '@/types'

interface BlockedUrlsCardProps {
  settings: EnterpriseSettings
  isAdmin: boolean
  authoringEnabled?: boolean
}

const BlockedUrlsCard = ({ settings, isAdmin, authoringEnabled = true }: BlockedUrlsCardProps) => {
  const [modalOpen, setModalOpen] = useState(false)

  const hosts = settings[SettingType.browserUrlDenyList] ?? []
  const label =
    hosts.length > 0 ? `Blocked URLs (${hosts.length} site${hosts.length === 1 ? '' : 's'})` : 'Blocked URLs'

  return (
    <>
      <div className={parentStyles.settingsItem}>
        <div className={parentStyles.toggleLabel}>{label}</div>
        <Button
          title={hosts.length > 0 ? 'Configure' : 'Add URLs'}
          onClick={() => setModalOpen(true)}
          type="dark"
          className={parentStyles.controlButton}
          isDisabled={!isAdmin && hosts.length === 0}
        />
      </div>

      <BlockedUrlsModal
        isOpen={modalOpen}
        close={() => setModalOpen(false)}
        currentList={hosts}
        isAdmin={isAdmin}
        authoringEnabled={authoringEnabled}
      />
    </>
  )
}

export default BlockedUrlsCard
